import React, { useEffect, useState } from 'react';
import './duration-timer.css';
const formatDuration = (seconds) => {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return `${hrs}:${mins}:${secs}`;
};

const MeetingDuration = ({ startTime }) => {
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const updateDuration = () => {
      const now = Date.now();
      const diffInSeconds = Math.floor((now - startTime) / 1000);
      setDuration(diffInSeconds);
    };

    const interval = setInterval(updateDuration, 1000);
    updateDuration(); // Initial call

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <div className='DurationTimer'>
      <p className='DurationTimer-time'>{formatDuration(duration)}</p>
    </div>
  );
};

export default MeetingDuration;
